import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import styled from 'styled-components';
import { Table, Thead, Tr, Th, Td, Tbody } from 'oxyrion-ui/lib/Table';
import { connect } from '../../Store';
import { __ } from '../../Utils';

const Wrapper = styled.div`
  padding-top: ${rem(7)};
  padding-bottom: ${rem(20)};
`;

const RoleLabel = styled.div`
  width: ${rem(10)};
  height: ${rem(10)};
  border-radius: ${rem(10)};
  background: ${props => (props.permited ? 'green' : 'red')};
`;

const RoleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

class RolesMapTable extends React.Component {
  render() {
    const { rolesMap } = this.props;

    return (
      <Wrapper>
        <Table>
          <Thead>
            <Tr>
              {rolesMap.headers.map(header => (
                <Th center>{__(header.label)}</Th>
              ))}
            </Tr>
          </Thead>
          <Tbody>
            {rolesMap.rows.map(row => (
              <Tr>
                {row.map(r => (
                  <Td>
                    {r.role ? (
                      <RoleWrapper>
                        <RoleLabel permited={r.label} />
                      </RoleWrapper>
                    ) : (
                      r.label
                    )}
                  </Td>
                ))}
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Wrapper>
    );
  }
}

RolesMapTable.propTypes = {
  rolesMap: PropTypes.shape({
    headers: PropTypes.arrayOf(PropTypes.shape),
    rows: PropTypes.arrayOf(PropTypes.shape),
  }).isRequired,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(RolesMapTable);



// WEBPACK FOOTER //
// ./src/Components/RolesMapTable/index.jsx